import apiClient from './apiClient';
import { Bill, CreateBillRequest, UpdateBillRequest, BillSummary, UserTodaySummary, MedicineBillingSummary, AdminBillingSummary } from '../types/Bill';

export const billService = {
  getAllBills: async (): Promise<Bill[]> => {
    const response = await apiClient.get('/bills');
    return response.data;
  },

  getBill: async (id: number): Promise<Bill> => {
    const response = await apiClient.get(`/bills/${id}`);
    return response.data;
  },

  getBillsByPatient: async (patientId: number): Promise<Bill[]> => {
    const response = await apiClient.get(`/bills/patient/${patientId}`);
    return response.data;
  },

  getBillsByStatus: async (status: string): Promise<Bill[]> => {
    const response = await apiClient.get(`/bills/status/${encodeURIComponent(status)}`);
    return response.data;
  },

  getOverdueBills: async (): Promise<Bill[]> => {
    const response = await apiClient.get('/bills/overdue');
    return response.data;
  },

  getBillSummary: async (): Promise<BillSummary> => {
    const response = await apiClient.get('/bills/summary');
    return response.data;
  },

  getMyTodaySummary: async (): Promise<UserTodaySummary> => {
    const response = await apiClient.get('/bills/my-today-summary');
    return response.data;
  },

  // Medicine/Pharmacy summary with date filter
  getMedicineSummary: async (date: string): Promise<MedicineBillingSummary> => {
    const response = await apiClient.get(`/bills/medicine-summary?date=${date}`);
    return response.data;
  },

  // Admin summary with optional date range filter
  getAdminSummary: async (startDate?: string, endDate?: string): Promise<AdminBillingSummary> => {
    let url = '/bills/admin-summary';
    const params: string[] = [];
    if (startDate) params.push(`startDate=${startDate}`);
    if (endDate) params.push(`endDate=${endDate}`);
    if (params.length > 0) url += `?${params.join('&')}`;
    const response = await apiClient.get(url);
    return response.data;
  },

  getBillsByDateRange: async (startDate: string, endDate: string): Promise<Bill[]> => {
    const response = await apiClient.get(`/bills/date-range?startDate=${startDate}&endDate=${endDate}`);
    return response.data;
  },

  createBill: async (bill: CreateBillRequest): Promise<Bill> => {
    const response = await apiClient.post('/bills', bill);
    return response.data;
  },

  updateBill: async (id: number, bill: UpdateBillRequest): Promise<Bill> => {
    const response = await apiClient.put(`/bills/${id}`, bill);
    return response.data;
  },

  updateBillStatus: async (id: number, status: string): Promise<void> => {
    await apiClient.patch(`/bills/${id}/status`, JSON.stringify(status), {
      headers: { 'Content-Type': 'application/json' }
    });
  },

  deleteBill: async (id: number): Promise<void> => {
    await apiClient.delete(`/bills/${id}`);
  }
};